import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tse/';

class TseService {
    constructor() {
        this.idCliente = null;
        this.idUsuario = null;
        LoginService.currentUser.subscribe(data => {
            this.token = data;
        });
    }
    downloadArquivoNF(dataInicial, dataFinal){
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idUsuario = LoginService.currentUserValue.usuario.idUsuario;
        return axios({
            url: API_URL + "arquivoNF?idCliente=" + this.idCliente + "&idUsuario=" + this.idCliente + (dataInicial ? ('&dataInicial=' + dataInicial) : "") + (dataFinal ? ('&dataFinal=' + dataFinal) : ""),
            method: "GET",
            responseType: "blob",
            data: null,
            headers: {
              'Content-Type':'text/plain',
              'authorization':'Bearer ' + (this.token ? this.token.token:'')
          }
        }).then(response => {
          var fileURL = window.URL.createObjectURL(
            new Blob([response.data], { type: "text/plain" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          //console.log(response);
          console.log( response.headers);
          let headerLine = response.headers['content-disposition']
          let startFileNameIndex = headerLine.indexOf('name="') + 5
          let endFileNameIndex = headerLine.lastIndexOf('"; filename')
          let filename = headerLine.substring(startFileNameIndex, endFileNameIndex)
          console.log(filename);
          fileLink.setAttribute("download", filename + ".txt");
          document.body.appendChild(fileLink);


          fileLink.click();
        });                                 
    }
}

export default new TseService();